import { render, staticRenderFns } from "./infineTab.vue?vue&type=template&id=7a2d7c7e&scoped=true&"
import script from "./infineTab.vue?vue&type=script&lang=js&"
export * from "./infineTab.vue?vue&type=script&lang=js&"
import style0 from "./infineTab.vue?vue&type=style&index=0&id=7a2d7c7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2d7c7e",
  null
  
)

export default component.exports